import { InjectionToken } from '@angular/core';
import { Router } from '@angular/router';
import { LenguagesHelper } from '@app/core/helpers/lenguages.helper';
import { ServiceLoader } from '../service-loader';

export const defaultErrors: { [property: string]: () => string } = {
    required: (): string => {
        let router: Router = ServiceLoader.injector.get(Router);
        let lenguagesHelper: LenguagesHelper = new LenguagesHelper();
        let lang: string = lenguagesHelper.extractLenguageFromPath(router.url);
        let error: any = {
            'es-AR': 'Este campo es requerido',
            'en-US': 'This field is required'
        };

        return error[lang] ?? error['es-AR'];
    },
    email: (): string => {
        let router: Router = ServiceLoader.injector.get(Router);
        let lenguagesHelper: LenguagesHelper = new LenguagesHelper();
        let lang: string = lenguagesHelper.extractLenguageFromPath(router.url);
        let error: any = {
            'es-AR': 'Correo electrónico incorrecto, debe ser por ejemplo: juan@dominio.com',
            'en-US': 'Incorrect email, it must be for example: juan@dominio.com'
        };

        return error[lang] ?? error['es-AR'];
    }
};

export const FORM_ERRORS: InjectionToken<{ [validator: string]: () => string }> = new InjectionToken('FORM_ERRORS', {
    providedIn: 'root',
    factory: (): { [validator: string]: () => string } => defaultErrors
});
